module.exports = __webpack_public_path__ + "assets/img/079b-dk.svg";